/**
 * Normal button style
 */
export const buttonStyle1 = {
  fontSize: '14px',
  height: '56px',
  fontWeight: '500',
  marginBottom: '0',
  marginTop: '15px',
  borderRadius: '4px',
};

export const buttonStyle2 = {
  height: '40px',
  width: '128px',
  borderRadius: '4px',
  fontFamily: 'Roboto',
  fontSize: '14px',
  fontWeight: '500',
};



/**
 * Add Button
 */
export const buttonStyle3 = {
  height: '32px',
  width: '96px',
  borderRadius: '20px',
  fontFamily: 'Roboto',
  fontSize: '12px',
  fontWeight: '500',
  marginRight: '10px',
  color: '#E9FCD3',
};

/**
 * editUser ButtonStyle
 */

export const dialogButtonStyle = {
  height: '40px',
  width: '128px',
  borderRadius: '4px',
  fontFamily: 'Roboto',
  fontSize: '14px',
  fontWeight: '500',
  color: '#FFF',
};

export const dialogButtonCancel = {
  height: '40px',
  width: '128px',
  borderRadius: '4px',
  fontFamily: 'Roboto',
  fontSize: '14px',
  fontWeight: '500',
};

export const buttonStyle4 = {
  // backgroundColor: '#8AC865',
  color: '#FFF',
  fontFamily: 'Roboto',
  fontSize: '14px',
  fontWeight: '500',
  minWidth: '152px',
  height: '40px',
  textTransform: 'none',
  marginRight: '24px',
  '&:hover': {
    // backgroundColor: '#8AC865'
  },
};
